import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ContentService } from '../services/content.service';
import { ResponseService } from '../services/response.service';
import { NavigationService } from '../services/navigation.service';
import { switchMap, catchError, map, of } from 'rxjs';

export function getDonorRedirectRoute(currentUrl: string) {
  const contentService = inject(ContentService);
  const responseService = inject(ResponseService);
  const navService = inject(NavigationService);
  const router = inject(Router);

  const initialQuestionnaireId = 'QT_3407cee8-027d-419e-9171-fae52d2753c9';

  return contentService.getDonorJourneySectionStatusForUser().pipe(
    switchMap((sections) => {
        
      if (!sections || sections.length === 0) {
        return of(isSameUrl('/questionnaire/preinitial', currentUrl) ? true : router.parseUrl('/questionnaire/preinitial'));
      }

      const initialStatus = sections[0]?.currentStatus;
      const comprehensiveStatus = sections[1]?.currentStatus;

      if (initialStatus === 'Not Started') {
        return of(isSameUrl('/questionnaire/preinitial', currentUrl) ? true : router.parseUrl('/questionnaire/preinitial'));
      }

      if (initialStatus === 'In Progress') {
        return of(isSameUrl('/questionnaire/iquestionnaire', currentUrl) ? true : router.parseUrl('/questionnaire/iquestionnaire'));
      }

      if (initialStatus === 'Under Review') {
        return responseService.getQuestionnaireByUserId().pipe(
          map((responses: any) => {
            const questionnaire = responses.find((r: any) => r.templateId === initialQuestionnaireId);

            if (questionnaire?.isIneligible) {
              // navService.setIneligibilityMessage(questionnaire.ineligibilityMessage);
              navService.setIneligibilityDetails({message: questionnaire.ineligibilityMessage, weightToLoseLbs: questionnaire.ineligibilityDetails?.weightToLoseLbs ?? undefined});
              return isSameUrl('/questionnaire/postinitialineligible', currentUrl)
                ? true
                : router.parseUrl('/questionnaire/postinitialineligible');
            }

            return true;
          }),
          catchError(() => of(true))
        );
      }

      return handleComprehensiveStatus(comprehensiveStatus, currentUrl, router, contentService);
    }),
    catchError((err) => {
      if (err?.status === 500) {
        console.error('Navigation halted due to server error (500).');
        return of(true);
      }
      return of(router.parseUrl('/questionnaire/preinitial'));
    })
  );
}

function handleComprehensiveStatus(status: string, currentUrl: string, router: Router, contentService: ContentService) {
  switch (status) {
    case 'Not Started':
      return of(isSameUrl('/questionnaire/postinitial', currentUrl) ? true : router.parseUrl('/questionnaire/postinitial'));
    case 'In Progress':
      return of(isSameUrl('/questionnaire/cquestionnaire', currentUrl) ? true : router.parseUrl('/questionnaire/cquestionnaire'));
    default:
      // Only call getContract if not already on /journey or /questionnaire/postcomprehensive
      if (isSameUrl('/journey', currentUrl) || isSameUrl('/questionnaire/postcomprehensive', currentUrl)) {
        return of(true);
      }
      return contentService.getContract().pipe(
        map((contract) => {
          if (contract && contract.status === 'contract-signed') {
            return router.parseUrl('/journey');
          } else {
            return router.parseUrl('/questionnaire/postcomprehensive');
          }
        }),
        catchError(() =>
          of(router.parseUrl('/questionnaire/postcomprehensive'))
        )
      );
  }
}

function isSameUrl(targetUrl: string, currentUrl: string): boolean {
  return currentUrl.startsWith(targetUrl);
}